import { render } from "./DialogFormMoins12.vue?vue&type=template&id=bac28f96&scoped=true"
import script from "./DialogFormMoins12.vue?vue&type=script&lang=js"
export * from "./DialogFormMoins12.vue?vue&type=script&lang=js"

import "./DialogFormMoins12.vue?vue&type=style&index=0&id=bac28f96&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac28f96"]])

export default __exports__